Controller = App.loadClass 'core::Angular/Controller'
Handler = App.loadClass 'core::Handler'

class exports.AddController extends Controller
    constructor: (@scope, @transitions, @data, @legacy, @state, @userSelection, @ngModal) ->

        super(@scope, @transitions)
        @scope.show_fullpage = false
        @scope.ngModalLauncherOptions = { resolve: { mode: 'Add' },  ngbModalOptions: { size: 'lg', windowClass: 'extra-wide-form' } }

        # This should be able to go away shortly, now that
        # separate states/controllers are set up for drawing/uploading
        if @state.params.fromDraw is 'true'
            @scope.selected_options.year = @userSelection.getYear()
            @scope.selected_options.field = @userSelection.getField()
            @scope.ngModalLauncherOptions.resolve.selectedField = @scope.selected_options.field
            @scope.ngModalLauncherOptions.resolve.year = @scope.selected_options.year

        # Event Listeners

        @scope.$on '$destroy', () =>
            # leave base layers on the map if they are drawing zones
            if @state.current.name isnt 'grower.data-define'
                @legacy.destroyAllSubHandlers()

            @baseHandler.destroyAllSubHandlers()

        @scope.$watch "selected_options.field", () =>
            if @scope.selected_options?.field?
                @scope.ngModalLauncherOptions.resolve.fieldId = @scope.selected_options.field.field_id
                @data.loadFieldBoundary(@scope.selected_options.field.field_id)

        @scope.$watch "selected_options.year", () =>
            if @scope.selected_options.year
                @scope.ngModalLauncherOptions.resolve.year = @scope.selected_options.year


        # Instantiate an old handler that can be used to launch things
        # TODO: this can probably go away and we can use @handler or something?
        @baseHandler = new Handler()
        @baseHandler.init()

        # Retrieve data from DataSidebarService (@data)
        @scope.years = @data.getSidebarYears() # 2008 through current year
        @loadScopeData @data.getSidebarFields(), 'fields'

        # Variable Declarations
        @scope.selected_options = @scope.$parent.selected_options
        @scope.selected_options.operation = null
        @scope.operations = @data.getOperations()

        # Variables for view manipulation
        @scope.add_data_type = ''
        @scope.add_form_type = 'plan'
        @scope.$watch 'add_form_type', (type) =>
            @scope.form_type_pretty = _.upperFirst(type)
            @scope.ngModalLauncherOptions.resolve.type = @scope.form_type_pretty
        @scope.selectedMapType = false
        @scope.uploadingMaps = false
        @scope.drawingMaps = false

        # Function Declarations
        @scope.addDataType = @addDataType
        @scope.launchForm = @launchForm
        @scope.launchLegacyForm = @launchLegacyForm
        @scope.launchDrawHandler = @launchDrawHandler
        @scope.destroyAllSubHandlers = @destroyAllSubHandlers
        @scope.uploadMaps = @uploadMaps
        @scope.drawMaps = @drawMaps

        if @state.includes('grower.data.add.upload')
            @scope.add_data_type = 'maps'
            @mapsToggle('uploading')

        if @state.includes('grower.data.add.draw')
            @scope.add_data_type = 'maps'
            @mapsToggle('drawing')

        # This integrates SAFElink functionality
        @scope.$on 'app:safelinked', () =>
            # Reset everything if safelinked to a new person
            @scope.$parent.selected_options.field = null
            @scope.selected_options.field = null
            @scope.add_data_type = ''
            @scope.add_form_type = 'plan'
            @scope.selected_options.operation = null
            @loadScopeData @data.getSidebarYears(), 'years'
            @loadScopeData @data.getAllYears(), 'all_years'
            @loadScopeData @data.getSidebarFields(), 'fields'


    destroyAllSubHandlers: () =>
        @legacy.destroyAllSubHandlers()

    # Resolve the promise and load data into the scope variable given by key
    loadScopeData: (promise, key) =>
        promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @scope[key] = response.data.data
        return promise

    # launch a form data dialog (angularized)
    launchForm: (form, type = null) =>
        opts = @scope.selected_options
        params =
            year: opts.year
            field_id: opts.field.field_id
            is_ingredion_field: if opts.field.external_name? and
                opts.field.external_name is 'Ingredion' and
                opts.field.external_permission then true else false

        if type?
            params.tab = type


        # {
        #     year: 2020,
        #     field_id: 43023,
        #     is_ingredion_field: false
        # }
        @state.go("grower.data.add.#{form}", params)

    # launch a legacy form data dialog
    launchLegacyForm: (form) =>
        if form is 'Ears, Rows, and Length'
            @ngModal.openERLDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Add')
            .modalRef.result.catch _.noop
        else if form is 'Harvest Load'
            @ngModal.openHarvestLoadDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Add')
            .modalRef.result.catch _.noop
        else if form is 'Stand Count'
            @ngModal.openStandCountDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Add')
            .modalRef.result.catch _.noop
        else
            @scope.postOps = {
                fields_id: @scope.selected_options.field.field_id
                field: @scope.selected_options.field.field_name
                has_edit: true
                id: null
                layer_id: null
                year: @scope.selected_options.year
            }

            @legacy.addLayer(form, @scope.postOps)

    # Method for launching the zone drawing process
    launchDrawHandler: () =>
        @state.go 'grower.data-define',
            field_id: @scope.selected_options.field.field_id
            year: @scope.selected_options.year


    # functions for toggles
    addDataType: (type) =>
        if type isnt @scope.add_data_type
            @state.go('grower.data.add')
        @scope.add_data_type = type

    mapsToggle: (selection) =>
        if selection is 'uploading'
            @scope.uploadingMaps = true
            @scope.drawingMaps = false
            @scope.selectedMapType = true
        else if selection is 'drawing'
            @scope.drawingMaps = true
            @scope.uploadingMaps = false
            @scope.selectedMapType = true
        else
            return

    uploadMaps: () =>
        @state.go('grower.data.add.upload')
        @mapsToggle('uploading')

    drawMaps: () =>
        @state.go('grower.data.add.draw')
        @mapsToggle('drawing')
